import * as React from "react";

const ArrowBlackSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32">
    <path
      fill="#171718"
      d="m12.71 24-1.42-1.42L17.87 16l-6.58-6.58L12.71 8l8 8z"
    ></path>
  </svg>
);

export default ArrowBlackSVG;
